// Achado de revisão (BLOQUEANTE, PR #1061): o guard de rotas em before-each.js é
// compartilhado por todos os módulos (Cadastros, Gestão dos Cadastros, Acessos,
// Parâmetros). Antes só existia um fallback fixo para /cadastros/buscar-empresas,
// então um usuário autenticado que só tivesse permissão de outro módulo (ex.:
// Acessos) caía no fail-secure e era bloqueado em /access-denied mesmo tendo para
// onde navegar. Esta lista espelha os itens de Sidebar.vue (mesmas permissões,
// mesmas urls) só com o necessário para o guard escolher a primeira rota acessível
// ao usuário antes de recorrer a /access-denied como último recurso.
export default [
  {
    path: "/cadastros/buscar-empresas",
    permissions: [
      "CENTRAL_CADASTROS_CONSULTAR",
      "CENTRAL_CADASTROS_EDITAR",
      "CENTRAL_CADASTROS_APROVAR",
      "CENTRAL_CADASTROS_PARAMETRIZAR",
      "CENTRAL_CADASTROS_INATIVAR_LOTE",
    ],
  },
  {
    path: "/buscar-usuarios",
    permissions: [
      "CENTRAL_CADASTROS_USUARIO_VISUALIZAR",
      "CENTRAL_CADASTROS_USUARIO_VISUALIZAR_EDITAR",
    ],
  },
  {
    path: "/buscar-grupos-de-acesso",
    permissions: [
      "CENTRAL_CADASTROS_GRUPO_ACESSO_VISUALIZAR",
      "CENTRAL_CADASTROS_GRUPO_ACESSO_VISUALIZAR_EDITAR",
    ],
  },
  {
    path: "/parametros-cadastro",
    permissions: [
      "CENTRAL_CADASTROS_PARAMETRIZAR",
      "CENTRAL_CADASTROS_INATIVAR_LOTE",
    ],
  },
];
